import { Pipe } from '@angular/core';
var InitialPipe = (function () {
    function InitialPipe() {
    }
    InitialPipe.prototype.transform = function (input, num) {
        if (num === void 0) { num = 0; }
        return Array.isArray(input)
            ? input.slice(0, input.length - num)
            : input;
    };
    InitialPipe.decorators = [
        { type: Pipe, args: [{ name: 'initial' },] },
    ];
    /** @nocollapse */
    InitialPipe.ctorParameters = function () { return []; };
    return InitialPipe;
}());
export { InitialPipe };
//# sourceMappingURL=initial.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/initial.js
// module id = 226
// module chunks = 4